import { z } from 'zod';

// UTR is 10 digits. "N/A" mode stores no number.
export const utrSchema = z.discriminatedUnion('mode', [
  z.object({
    mode: z.literal('enter'),
    number: z
      .string({ required_error: 'Enter your 10-digit UTR' })
      .trim()
      .regex(/^\d{10}$/, 'UTR must be exactly 10 digits'),
  }),
  z.object({
    mode: z.literal('na'),
  }),
]);

export type Utr = z.infer<typeof utrSchema>;
